import { EditorSDK } from '@wix/platform-editor-sdk';
import { IFedOpsLogger } from '@wix/native-components-infra/dist/src/types/types';
import {
  installationUncompleted,
  installationUncompletedDeprecated,
} from '../editor-sdk-actions';
import { EditorScriptApi } from '../../api/api';
import { openEcomHistoryBlockModal } from '../migration-modals';
import { migrateAction, MigrateAction } from '../../migration';
import { completeInstallationAction } from './complete-installation-action';
import { Translations } from '../translations';
import { Actions, reportBi } from '../editor-script-bi-logger';
import { isExperimentEnabled } from '../experiments';
import { experiments } from '../../constants';

interface CompleteInstallationParams {
  isFirstInstall: boolean;
  editorOrigin: string;
  msid: string;
  _editorSDK: EditorSDK;
  editorScriptApi: EditorScriptApi;
  appToken?: string;
  editorTranslation: Translations;
  fedopsLogger: IFedOpsLogger;
  completeInstall?: MigrateAction;
  instance: string;
  locale?: any;
}

export const validateInstallationCompleted = async ({
  isFirstInstall,
  _editorSDK,
  editorScriptApi,
  appToken,
  locale,
  fedopsLogger,
  msid,
  editorOrigin,
  completeInstall,
}: CompleteInstallationParams) => {
  try {
    if (!isFirstInstall && completeInstall) {
      const isImproveFixSiteEnabled = await isExperimentEnabled(
        experiments.IMPROVE_FIX_SITE,
      );
      const isInstallationUncompleted = isImproveFixSiteEnabled
        ? await installationUncompleted(_editorSDK, editorScriptApi, appToken!)
        : await installationUncompletedDeprecated(
            _editorSDK,
            editorScriptApi,
            appToken!,
          );

      if (isInstallationUncompleted) {
        fedopsLogger.interactionStarted(Actions.FIX_SITE);
        if (isImproveFixSiteEnabled) {
          await completeInstallationAction(completeInstall);
        } else {
          await migrateAction(completeInstall);
        }
        fedopsLogger.interactionEnded(Actions.FIX_SITE);
      }
    }
  } catch (e) {
    openEcomHistoryBlockModal(
      _editorSDK,
      editorScriptApi,
      locale,
      completeInstall.instance,
    );

    const errorMessage = `${
      e?.message ? e.message : JSON.stringify(e)
    } - Action ${Actions.FIX_SITE}`;
    reportBi({
      msid,
      origin: editorOrigin,
      isFirstInstall,
      actionType: Actions.FIX_SITE,
      actionSucceed: false,
      errorMessage,
    });
  }
};
